import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Gavel, Balance, Security } from '@mui/icons-material';

interface LogoProps {
  variant?: 'full' | 'icon';
  color?: 'light' | 'dark';
}

const Logo: React.FC<LogoProps> = ({ variant = 'full', color = 'dark' }) => {
  const theme = useTheme();
  const textColor = color === 'light' ? '#FFFFFF' : theme.palette.text.primary;
  const accentColor = color === 'light' ? '#FFFFFF' : theme.palette.secondary.main;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Box 
        sx={{ 
          position: 'relative', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
        }}
      >
        <Balance
          sx={{
            fontSize: variant === 'full' ? 36 : 30,
            color: accentColor,
            position: 'relative',
            zIndex: 2,
            filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.15))',
          }}
        />
        <Security 
          sx={{
            fontSize: variant === 'full' ? 24 : 20,
            color: color === 'light' ? 'rgba(255,255,255,0.7)' : theme.palette.primary.main,
            position: 'absolute',
            left: variant === 'full' ? -8 : -6,
            bottom: variant === 'full' ? -6 : -5,
            zIndex: 1,
            opacity: 0.85,
          }}
        />
      </Box>
      
      {variant === 'full' && (
        <Box>
          <Typography
            variant="h6"
            component="span"
            sx={{
              fontWeight: 800,
              color: textColor,
              letterSpacing: '0.8px',
              fontSize: '1.25rem',
              textShadow: color === 'light' ? '0 2px 4px rgba(0,0,0,0.15)' : 'none',
              fontFamily: '"Poppins", sans-serif',
              display: 'block',
              lineHeight: 1.1,
            }}
          >
            CHISHTY UK
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: textColor,
              opacity: 0.9,
              letterSpacing: '1.2px',
              fontSize: '0.7rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              borderTop: `2px solid ${accentColor}`,
              paddingTop: '3px',
              marginTop: '2px',
              display: 'inline-block',
            }}
          >
            Immigration Law & Visa Advisor
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default Logo; 